import Modal from "@kamae-apps/shared/old/Component/Modal/Modal"
import React, { FC } from "react"
import Spinner from "../../Icons/Spinner"
import { UserData } from "../User"
import { useSendMonthlyRecapModal } from "./useSendMonthlyRecapModal"

interface SendMonthlyRecapModalProps {
  display: boolean
  setDisplay: React.Dispatch<React.SetStateAction<boolean>>
  userData: UserData
}

export const SendMonthlyRecapModal: FC<SendMonthlyRecapModalProps> = (props: SendMonthlyRecapModalProps) => {
  const { loading, setLoading, title, header, button, sendMonthlyRecap } = useSendMonthlyRecapModal({
    userData: props.userData,
  })
  return (
    <Modal
      title={title}
      display={props.display}
      setDisplay={props.setDisplay}
      width={"w-3/5"}
    >
      <div className={"flex w-full flex-col items-center px-4"}>
        <p className={"text-center text-xl"}>
          <span className={"text-red-500"}>{header}</span>
          <br />
          {props.userData.last_name} {props.userData.first_name}
          <br />
          {props.userData.email} ?
        </p>
        <div className={"mt-10 mb-4"}>
          <button
            disabled={loading}
            className={
              "mx-2 rounded border-2 border-red-500 px-4 py-2 text-red-500 transition-colors hover:bg-red-500 hover:text-white"
            }
            onClick={() => {
              setLoading(true)
              sendMonthlyRecap()
            }}
          >
            {loading && <Spinner />}
            {button}
          </button>
          <button
            className={
              "mx-4 rounded border-2 border-slate-400 px-8 py-2 text-slate-400 transition-colors hover:bg-slate-400 hover:text-white"
            }
            onClick={() => props.setDisplay(false)}
          >
            Annuler
          </button>
        </div>
      </div>
    </Modal>
  )
}
